import React, { useEffect, useState } from "react";
import cn from "classnames";
import { Formik, Form, Field } from "formik";

import * as Yup from "yup";

import styles from "./PrintBarcodeTemplate.module.sass";
import Card from "../../../components/Card";

import TextInput from "../../../components/TextInput";
import Image from "../../../components/Image";
import { useNavigate } from "react-router-dom";
import ProductTag from "../../../assets/images/product_tag.svg";
import { message } from "antd";
import {
  get_all_products,
  get_one_product,
  get_products_by_name,
} from "../../../API/Product";

import Dropdown from "../../../components/Dropdown";
import Modal from "../../../components/Modal";

import Table from "../Table";
import Product from "../Product";
import SearchedProduct from "../SearchedProduct";

import {
  get_all_barcode_templates,
  get_printer_brands,
  get_label_codes,
  get_label_components,
  get_label_units,
  create_custom_barcode_template,
  update_custom_barcode_template,
  get_all_barcode_symbols,
  get_one_label_code,
} from "../../../API/PrintBarcode";
import { useData } from "../../../context/Barcode/BarcodeContext";
const NameAndDescription = ({ className }) => {
  const navigate = useNavigate();
  const { setAboveLabel, setBelowLabel } = useData();
  const formikRef = React.useRef();
  const [products, setProducts] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [searchedProducts, setSearchedProducts] = useState([]);
  const [savedTemplates, setSavedTemplates] = useState([]);
  const [printerBrands, setPrinterBrands] = useState([]);
  const [labelCodes, setLabelCodes] = useState([]);
  const [labelUnits, setLabelUnits] = useState([]);
  const [visibleModal, setVisibleModal] = useState(false);
  const [labelComponents, setLabelComponents] = useState([]);
  const [viewScanScreen, setViewScanScreen] = useState(false);
  const [barcodeSymbol, setBarcodeSymbol] = useState([]);
  const templateDefaultValue = {
    label_code_id: null,
    printer_brand_type: "Custom",
    no_of_rows: 1,
    no_of_columns: 1,
    width: 15,
    height: 15,
    units: "mm",
    top_padding: "",
    bottom_padding: "",
    left_padding: "",
    right_padding: "",
    barcode_symbol: "sku",
    above_barcode_value: "",
    below_barcode_value: "",
    name: "",
    title: "None",
  };
  const formatLabel = (text) => {
    return text
      .replace(/_/g, " ")
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  const handleTemplateChange = (savedTemplate) => {
    if (savedTemplate.name != "None") {
      setInitialValue({ ...savedTemplate, title: savedTemplate.id });
      setAboveLabel(formatLabel(savedTemplate.above_barcode_value));
      setBelowLabel(formatLabel(savedTemplate.below_barcode_value));
    } else {
      setInitialValue({ ...templateDefaultValue, id: "None" });
    }
  };
  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      const getChangedValues = (initialValues, currentValues) => {
        const changedValues = {};
        Object.keys(currentValues).forEach((key) => {
          if (initialValues[key] !== currentValues[key]) {
            changedValues[key] = currentValues[key];
          }
        });
        return changedValues;
      };

      const changedValues = getChangedValues(initialValues, values);
      if (values.title == "None") {
        const res = await create_custom_barcode_template(values);
        if (res.status == 201) {
          const newTemplate = res.data.data;
          setSavedTemplates((prevTemplates) => [...prevTemplates, newTemplate]);
          setInitialValue({ ...newTemplate, title: newTemplate.id });
          message.success(res.data.message);
        }
      } else {
        const templateId = initialValues.title;
        const res = await update_custom_barcode_template(templateId, values);
        const updatedTemplate = res.data.data;

        if (res.status == 200) {
          setSavedTemplates((prevTemplates) =>
            prevTemplates.map((template) =>
              template.id === updatedTemplate.id
                ? { ...template, ...updatedTemplate }
                : template
            )
          );
          setInitialValue({ ...updatedTemplate, title: updatedTemplate.id });
          message.success(res.data.message);
        }
      }
      // resetForm();
    } catch (error) {
      message.error(error.response.data.err);
    }
    setSubmitting(false);
  };

  const [initialValues, setInitialValue] = useState(templateDefaultValue);
  const [searchInitialValue, setSearchInitialValue] = useState({
    productSearchString: "",
  });

  const validationSchema = Yup.object().shape({
    printer_brand_type: Yup.string().required("Printer brand is required"),

    label_code_id: Yup.string().when("printer_brand_type", {
      is: (val) => val !== "Custom",
      then: (schema) => schema.required("Label Code is required"),
      otherwise: (schema) => schema.notRequired(),
    }),

    width: Yup.number()
      .nullable()
      .when("printer_brand_type", {
        is: "Custom",
        then: (schema) =>
          schema
            .required("Width is required")
            .positive("Width must be greater than 0"),
        otherwise: (schema) => schema.notRequired(),
      }),

    height: Yup.number()
      .nullable()
      .when("printer_brand_type", {
        is: "Custom",
        then: (schema) =>
          schema
            .required("Height is required")
            .positive("Height must be greater than 0"),
        otherwise: (schema) => schema.notRequired(),
      }),
    width: Yup.number()
      .nullable()
      .when("printer_brand_type", {
        is: "Custom",
        then: (schema) =>
          schema
            .required("Width is required")
            .positive("Width must be greater than 0"),
        otherwise: (schema) => schema.notRequired(),
      }),

    units: Yup.string()
      .nullable()
      .when("printer_brand_type", {
        is: "Custom",
        then: (schema) => schema.required("Units are required"),
        otherwise: (schema) => schema.notRequired(),
      }),
    top_padding: Yup.number()
      .nullable()
      .when("printer_brand_type", {
        is: "Custom",
        then: (schema) =>
          schema
            .required("Top padding is required")
            .positive("Top padding must be greater than 0"),
        otherwise: (schema) => schema.notRequired(),
      }),
    bottom_padding: Yup.number()
      .nullable()
      .when("printer_brand_type", {
        is: "Custom",
        then: (schema) =>
          schema
            .required("Bottom padding is required")
            .positive("Bottom padding must be greater than 0"),
        otherwise: (schema) => schema.notRequired(),
      }),
    left_padding: Yup.number()
      .nullable()
      .when("printer_brand_type", {
        is: "Custom",
        then: (schema) =>
          schema
            .required("Left padding is required")
            .positive("Left padding must be greater than 0"),
        otherwise: (schema) => schema.notRequired(),
      }),
    right_padding: Yup.number()
      .nullable()
      .when("printer_brand_type", {
        is: "Custom",
        then: (schema) =>
          schema
            .required("Right padding is required")
            .positive("Right padding must be greater than 0"),
        otherwise: (schema) => schema.notRequired(),
      }),
    barcode_symbol: Yup.string()
      .nullable()
      .required("Barcode symbol is required"),
    above_barcode_value: Yup.string()
      .nullable()
      .required("Above barcode value is required"),
    below_barcode_value: Yup.string()
      .nullable()
      .required("Below barcode value is required"),
    name: Yup.string().nullable().required("Name is required"),
  });
  useEffect(() => {
    const fetchTemplates = async () => {
      try {
        const response = await get_all_barcode_templates();

        setSavedTemplates([{ id: "None", name: "None" }, ...response.data]);
      } catch (error) {
        console.error("Failed to fetch barcode template");
      }
    };
    const fetchPrinterBrands = async () => {
      try {
        const response = await get_printer_brands();

        setPrinterBrands([...response.data]);
      } catch (error) {
        console.error("Failed to fetch printer brands.");
      }
    };
    const fetchLabelCodes = async () => {
      try {
        const response = await get_label_codes();

        setLabelCodes([...response.data]);
      } catch (error) {
        console.error("Failed to fetch label codes.");
      }
    };
    const fetchLabelComponents = async () => {
      try {
        const response = await get_label_components();

        setLabelComponents([...response.data]);
      } catch (error) {
        console.error("Failed to fetch labels.");
      }
    };
    const fetchLabelUnits = async () => {
      try {
        const response = await get_label_units();

        setLabelUnits([...response.data]);
      } catch (error) {
        console.error("Failed to fetch units.");
      }
    };

    const fetchAllProducts = async () => {
      try {
        const response = await get_all_products();

        setProducts([...response.data.data]);
      } catch (error) {
        console.error("Failed to fetch product.");
      }
    };

    const fetchAllBarcodeSymbol = async () => {
      try {
        const response = await get_all_barcode_symbols();

        setBarcodeSymbol([...response.data]);
      } catch (error) {
        console.error("Failed to fetch barcode.");
      }
    };

    fetchTemplates();
    fetchPrinterBrands();
    // fetchLabelCodes();
    fetchLabelComponents();
    fetchLabelUnits();
    fetchAllProducts();
    fetchAllBarcodeSymbol();
  }, []);

  const fetchOneLabelCode = async (id) => {
    try {
      const response = await get_one_label_code(id);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch label codes");
    }
  };

  const handleProductSearch = async (productSearchString) => {
    try {
      if (productSearchString && productSearchString !== "") {
        const response = await get_one_product(productSearchString);
        const product = response.data;

        setSearchedProducts((prevProducts) => {
          return prevProducts
            .map((p) =>
              p.id === product.id
                ? { ...p, barcodeQuantity: (p.barcodeQuantity || 1) + 1 } // Increment barcodeQuantity
                : p
            )
            .concat(
              prevProducts.some((p) => p.id === product.id)
                ? []
                : [{ ...product, barcodeQuantity: 1 }]
            ); // Add new product with barcodeQuantity 1 if not found
        });
      }
    } catch (error) {
      message.error("Failed to fetch Products");
    }
  };
  const handleSelectedProductSearch = async (productSearchString) => {
    try {
      if (productSearchString && productSearchString !== "") {
        const response = await get_products_by_name(productSearchString);
        const product = response.data;
        setProducts(response.data);
      }
    } catch (error) {
      message.error("Failed to fetch Products");
    }
  };
  const fetchLabelCodes = async (printer_brand) => {
    try {
      const response = await get_label_codes(printer_brand);

      setLabelCodes([...response.data]);
    } catch (error) {
      console.error("Failed to fetch label codes.");
    }
  };

  const handlePrinterChange = async (value, setFieldValue) => {
    if (value !== "Custom") {
      const res = await fetchLabelCodes(value);
    } else {
      await fetchLabelCodes();
    }
  };

  const removeSearchedProduct = (delProduct) => {
    setSearchedProducts((prevProducts) =>
      prevProducts.filter((product) => product.id !== delProduct.id)
    );
  };
  const removeSelectedProduct = (delProduct) => {
    setSelectedProducts((prevProducts) =>
      prevProducts.filter((product) => product.id !== delProduct.id)
    );
  };
  const printLabels = async () => {
    if (formikRef.current.values.label_code_id) {
      const label = await fetchOneLabelCode(
        formikRef.current.values.label_code_id
      );

      const tagData = {
        rows: label.no_of_rows,
        cols: label.no_of_columns,
        height: label.height,
        width: label.width,
        above_barcode: formikRef.current.values.above_barcode_value,
        below_barcode: formikRef.current.values.below_barcode_value,
        barcode_symbol: formikRef.current.values.barcode_symbol,
        products:
          searchedProducts.length > 0
            ? [...searchedProducts]
            : [...selectedProducts],
      };
      navigate("/dynamic-barcode-print", { state: tagData });
    } else {
      const tagData = {
        height: formikRef.current.values.height,
        width: formikRef.current.values.width,
        above_barcode: formikRef.current.values.above_barcode_value,
        below_barcode: formikRef.current.values.below_barcode_value,
        barcode_symbol: formikRef.current.values.barcode_symbol,
        products:
          searchedProducts.length > 0
            ? [...searchedProducts]
            : [...selectedProducts],
      };
      navigate("/dynamic-barcode-print", { state: tagData });
    }
  };

  return (
    <div className={styles.description}>
      <Formik
        initialValues={initialValues}
        enableReinitialize
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        innerRef={formikRef}
      >
        {({ isSubmitting, setFieldValue, values, errors, touched }) => {
          const isCustomBrand = values.printer_brand_type === "Custom";
          return (
            <Form>
              <Card
                className={cn(styles.card, className)}
                title="Saved Label Templates"
                classTitle="title-purple"
              >
                <div className={styles.field_container}>
                  <Field name="title">
                    {({ field, meta }) => (
                      <Dropdown
                        className={styles.field}
                        label=""
                        value={
                          savedTemplates.find(
                            (option) => option.id === values.title
                          )?.name || ""
                        }
                        setValue={(value) => {
                          const selectedTemplate = savedTemplates.find(
                            (option) => option.name === value
                          );
                          setFieldValue(
                            "title",
                            savedTemplates.find(
                              (option) => option.name === value
                            )?.id || ""
                          );
                          if (selectedTemplate) {
                            handleTemplateChange(selectedTemplate); // Pass the entire object
                          }
                        }}
                        options={savedTemplates.map((option) => option.name)}
                        error={meta.touched && meta.error ? meta.error : ""}
                        disabled={false}
                      />
                    )}
                  </Field>
                </div>
              </Card>
              <Card
                className={cn(styles.card, className)}
                title="Label Dimensions"
                classTitle="title-blue"
              >
                <div className={styles.price}>
                  <div className={styles.field_container}>
                    <Field name="printer_brand_type">
                      {({ field, meta }) => (
                        <Dropdown
                          className={styles.field}
                          label="Printer Brand / Custom"
                          tooltip="Maximum 100 characters. No HTML or emoji allowed"
                          value={
                            printerBrands.find(
                              (option) =>
                                option.value === values.printer_brand_type
                            )?.label || ""
                          }
                          setValue={(value) => {
                            setFieldValue(
                              "printer_brand_type",
                              printerBrands.find(
                                (option) => option.label === value
                              )?.value || ""
                            );
                            // Clear other fields
                            setFieldValue("label_code_id", "");
                            setFieldValue("width", "");
                            setFieldValue("height", "");
                            setFieldValue("units", "");
                            setFieldValue("top_padding", "");
                            setFieldValue("bottom_padding", "");
                            setFieldValue("left_padding", "");
                            setFieldValue("right_padding", "");
                            handlePrinterChange(value, setFieldValue);
                          }}
                          options={printerBrands.map((option) => option.label)}
                          error={meta.touched && meta.error ? meta.error : ""}
                          disabled={false}
                        />
                      )}
                    </Field>
                  </div>
                  <div className={styles.field_container}>
                    <Field name="label_code_id">
                      {({ field, meta }) => (
                        <Dropdown
                          className={styles.field}
                          label="Label Codes"
                          {...field}
                          tooltip="Maximum 100 characters. No HTML or emoji allowed"
                          value={
                            labelCodes.find(
                              (option) => option.value === values.label_code_id
                            )?.label || ""
                          }
                          setValue={(value) =>
                            setFieldValue(
                              "label_code_id",
                              labelCodes.find(
                                (option) => option.label === value
                              )?.value || ""
                            )
                          }
                          options={labelCodes.map((option) => option.label)}
                          error={meta.touched && meta.error ? meta.error : ""}
                          disabled={isCustomBrand}
                        />
                      )}
                    </Field>
                  </div>
                  <div className={styles.fieldset}>
                    <Field name="width">
                      {({ field, meta }) => (
                        <TextInput
                          {...field}
                          value={values.width}
                          label="Width"
                          tooltip="Maximum 100 characters. No HTML or emoji allowed"
                          className={styles.field}
                          error={meta.touched && meta.error ? meta.error : ""}
                          disabled={!isCustomBrand}
                        />
                      )}
                    </Field>
                    <Field name="height">
                      {({ field, meta }) => (
                        <TextInput
                          {...field}
                          value={values.height}
                          label="Height"
                          tooltip="Maximum 100 characters. No HTML or emoji allowed"
                          className={styles.field}
                          error={meta.touched && meta.error ? meta.error : ""}
                          disabled={!isCustomBrand}
                        />
                      )}
                    </Field>
                  </div>
                  <div className={styles.fieldset}>
                    <Field name="top_padding">
                      {({ field, meta }) => (
                        <TextInput
                          {...field}
                          value={values.top_padding}
                          label="Top Padding"
                          tooltip="Maximum 100 characters. No HTML or emoji allowed"
                          className={styles.field}
                          error={meta.touched && meta.error ? meta.error : ""}
                          disabled={!isCustomBrand}
                        />
                      )}
                    </Field>
                    <Field name="bottom_padding">
                      {({ field, meta }) => (
                        <TextInput
                          {...field}
                          value={values.bottom_padding}
                          label="Bottom Padding"
                          tooltip="Maximum 100 characters. No HTML or emoji allowed"
                          className={styles.field}
                          error={meta.touched && meta.error ? meta.error : ""}
                          disabled={!isCustomBrand}
                        />
                      )}
                    </Field>
                  </div>
                  <div className={styles.fieldset}>
                    <Field name="left_padding">
                      {({ field, meta }) => (
                        <TextInput
                          {...field}
                          value={values.left_padding}
                          label="Left Padding"
                          tooltip="Maximum 100 characters. No HTML or emoji allowed"
                          className={styles.field}
                          error={meta.touched && meta.error ? meta.error : ""}
                          disabled={!isCustomBrand}
                        />
                      )}
                    </Field>
                    <Field name="right_padding">
                      {({ field, meta }) => (
                        <TextInput
                          {...field}
                          value={values.right_padding}
                          label="Right Padding"
                          tooltip="Maximum 100 characters. No HTML or emoji allowed"
                          className={styles.field}
                          error={meta.touched && meta.error ? meta.error : ""}
                          disabled={!isCustomBrand}
                        />
                      )}
                    </Field>
                  </div>
                  <div className={styles.dropdown}>
                    <Field name="units">
                      {({ field, meta }) => (
                        <Dropdown
                          label="Units"
                          {...field}
                          tooltip="Maximum 100 characters. No HTML or emoji allowed"
                          value={
                            labelUnits.find(
                              (option) => option.value === values.units
                            )?.label || ""
                          }
                          setValue={(value) =>
                            setFieldValue(
                              "units",
                              labelUnits.find(
                                (option) => option.label === value
                              )?.value || ""
                            )
                          }
                          disabled={values.label_code_id}
                          options={labelUnits.map((option) => option.label)}
                          error={meta.touched && meta.error ? meta.error : ""}
                        />
                      )}
                    </Field>
                  </div>
                </div>
              </Card>
              <Card
                className={cn(styles.card, className)}
                title="Label Layout"
                classTitle="title-red"
              >
                <div>
                  <div className={styles.tags_container}>
                    <div className={styles.dropdown}>
                      <Field name="above_barcode_value">
                        {({ field, meta }) => (
                          <Dropdown
                            className={styles.field}
                            label="Above the Barcode Symbol"
                            {...field}
                            tooltip="Maximum 100 characters. No HTML or emoji allowed"
                            value={
                              labelComponents.find(
                                (option) =>
                                  option.value === values.above_barcode_value
                              )?.label || ""
                            }
                            setValue={(value) => {
                              setFieldValue(
                                "above_barcode_value",
                                labelComponents.find(
                                  (option) => option.label === value
                                )?.value || ""
                              );

                              setAboveLabel(
                                labelComponents.find(
                                  (option) => option.label === value
                                )?.label || ""
                              );
                            }}
                            options={labelComponents.map(
                              (option) => option.label
                            )}
                            error={meta.touched && meta.error ? meta.error : ""}
                            disabled={false}
                          />
                        )}
                      </Field>
                    </div>
                    <div className={styles.dropdown}>
                      {" "}
                      <Field name="below_barcode_value">
                        {({ field, meta }) => (
                          <Dropdown
                            className={styles.field}
                            label="Below the Barcode Symbol"
                            {...field}
                            value={
                              labelComponents.find(
                                (option) =>
                                  option.value === values.below_barcode_value
                              )?.label || ""
                            }
                            setValue={(value) => {
                              setFieldValue(
                                "below_barcode_value",
                                labelComponents.find(
                                  (option) => option.label === value
                                )?.value || ""
                              );
                              setBelowLabel(
                                labelComponents.find(
                                  (option) => option.label === value
                                )?.label || ""
                              );
                            }}
                            options={labelComponents.map(
                              (option) => option.label
                            )}
                            error={meta.touched && meta.error ? meta.error : ""}
                            disabled={false}
                          />
                        )}
                      </Field>
                    </div>
                    <div className={styles.dropdown}>
                      {" "}
                      <Field name="barcode_symbol">
                        {({ field, meta }) => (
                          <Dropdown
                            className={styles.field}
                            label="Generate the Barcode Symbol from the"
                            {...field}
                            value={
                              barcodeSymbol.find(
                                (option) =>
                                  option.value === values.barcode_symbol
                              )?.label || ""
                            }
                            setValue={(value) =>
                              setFieldValue(
                                "barcode_symbol",
                                barcodeSymbol.find(
                                  (option) => option.label === value
                                )?.value || ""
                              )
                            }
                            options={barcodeSymbol.map(
                              (option) => option.label
                            )}
                            error={meta.touched && meta.error ? meta.error : ""}
                            disabled={false}
                          />
                        )}
                      </Field>
                    </div>
                  </div>
                </div>
              </Card>
              <Card
                className={cn(styles.card, className)}
                title="Save Label Template"
                classTitle="title-green"
              >
                <div className={styles.price}>
                  <Field name="name">
                    {({ field, meta }) => (
                      <TextInput
                        {...field}
                        value={values.name}
                        label="Template Name"
                        tooltip="Maximum 100 characters. No HTML or emoji allowed"
                        className={styles.field}
                        error={meta.touched && meta.error ? meta.error : ""}
                      />
                    )}
                  </Field>
                </div>
                <button
                  type="submit"
                  className={cn("button-stroke button-small", styles.button)}
                >
                  {values.title == "None" || !values.title
                    ? "Save Template"
                    : "Update Template"}
                </button>
              </Card>
            </Form>
          );
        }}
      </Formik>
      <Card
        className={cn(styles.card, className)}
        title="SKU Labels"
        classTitle="title-blue"
        head={
          <div>
            <button
              className={cn(
                !viewScanScreen && selectedProducts.length == 0
                  ? styles.clear_button
                  : styles.clear_button_active
              )}
              onClick={() => {
                setSearchedProducts([]);
                setSelectedProducts([]);
              }}
            >
              Clear All
            </button>
          </div>
        }
      >
        {" "}
        {selectedProducts.length > 0 && (
          <div>
            <Product
              items={selectedProducts}
              removeSelectedProduct={removeSelectedProduct}
              setSelectedProducts={setSelectedProducts}
            />
            <button
              className={cn("button", styles.button)}
              onClick={() => setVisibleModal(true)}
            >
              Add Products
            </button>
          </div>
        )}
        <div className={styles.sku_button_container}>
          {!viewScanScreen && selectedProducts.length == 0 && (
            <>
              <div className={styles.sku_container}>
                <Image
                  className={styles.pic}
                  src={ProductTag}
                  srcDark={ProductTag}
                  alt="Core"
                />
              </div>
              <div className={styles.sku_container}>
                <button
                  className={cn("button", styles.button)}
                  onClick={() => {
                    setVisibleModal(true);
                  }}
                >
                  Select Products
                </button>
                <button
                  className={cn("button", styles.button)}
                  onClick={() => setViewScanScreen(true)}
                >
                  Scan Products
                </button>
              </div>
            </>
          )}
        </div>
        {viewScanScreen ? (
          <div>
            <Formik initialValues={searchInitialValue} enableReinitialize>
              {({ isSubmitting, setFieldValue, values, resetForm }) => {
                return (
                  <Form>
                    <Field name="productSearchString">
                      {({ field, meta }) => (
                        <TextInput
                          {...field}
                          value={values.productSearchString} // Correct field value
                          label="Search By SKU/Barcode"
                          tooltip="Maximum 100 characters. No HTML or emoji allowed"
                          className={styles.field}
                          error={meta.touched && meta.error ? meta.error : ""}
                          autoFocus={true}
                          onChange={(e) => {
                            setFieldValue(
                              "productSearchString",
                              e.target.value
                            );
                          }}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              e.preventDefault(); // Prevent form submission
                              handleProductSearch(values.productSearchString);
                              resetForm(); // Reset form properly
                            }
                          }}
                          onBlur={() => {
                            handleProductSearch(values.productSearchString);
                            resetForm(); // Reset form properly
                          }}
                        />
                      )}
                    </Field>
                    {!searchedProducts.length && (
                      <div>
                        <div className={styles.sku_container}>
                          <p>Scan you products to create labels</p>{" "}
                        </div>
                        <div className={styles.sku_container}>
                          <button
                            className={cn("button-stroke", styles.button)}
                            onClick={() => {
                              setSearchedProducts([]);
                              setViewScanScreen(false);
                            }}
                          >
                            <span>Cancel</span>
                          </button>
                        </div>
                      </div>
                    )}
                  </Form>
                );
              }}
            </Formik>
            <div className={styles.sku_labels_container}>
              {searchedProducts.length > 0 && (
                <SearchedProduct
                  items={searchedProducts}
                  removeSearchedProduct={removeSearchedProduct}
                  setSearchedProducts={setSearchedProducts}
                />
              )}
            </div>
          </div>
        ) : (
          <div></div>
        )}
      </Card>
      <div className={cn("panel", styles.panel)}>
        <div className={styles.info}></div>
        <div className={styles.btns}>
          <button
            className={cn("button", styles.button)}
            onClick={printLabels}
            disabled={!(searchedProducts.length || selectedProducts.length)}
          >
            Print All Labels
          </button>
        </div>
      </div>
      <Modal
        visible={visibleModal}
        onClose={() => setVisibleModal(false)}
        outerClassName={styles.modal_container}
      >
        <Card
          className={styles.card}
          classCardHead={styles.head}
          title="Add Products"
          classTitle={cn("title-green", styles.title)}
        >
          <Formik initialValues={searchInitialValue} enableReinitialize>
            {({ isSubmitting, setFieldValue, values, resetForm }) => {
              return (
                <Form>
                  <Field name="productSearchString">
                    {({ field, meta }) => (
                      <TextInput
                        {...field}
                        value={values.productSearchString} // Correct field value
                        label="Search Productss"
                        tooltip="Maximum 100 characters. No HTML or emoji allowed"
                        className={styles.field}
                        error={meta.touched && meta.error ? meta.error : ""}
                        autoFocus={true}
                        onChange={(e) => {
                          setFieldValue("productSearchString", e.target.value);
                          handleSelectedProductSearch(
                            values.productSearchString
                          );
                        }}
                      />
                    )}
                  </Field>
                </Form>
              );
            }}
          </Formik>
          <div className={styles.wrapper}>
            <Table
              setVisibleModal={setVisibleModal}
              items={products}
              title="Last edited"
              setSelectedProducts={setSelectedProducts}
              selectedProducts={selectedProducts}
            />
          </div>
        </Card>
      </Modal>
    </div>
  );
};

export default NameAndDescription;
